import router from '@/router/router';
import { getStore, setStore } from '@/util/store';
import { matchUrl,encrypt, decrypt} from '@/util/util';
import { boardGetCusList } from '@/api/v2/stats/data-center/board';
import {
  cacheUser,
  getAllOrg,
  getFacilitatorId,
  getUserInfo,
  loginByUsername,
  ygjLogon,
  loginByPhone,
  logout,
 requestRefreshToken
} from '@/api/user/login';
import store from "@/store";
import pubIndexCIIC from "@/views/pub/pubIndexCIIC";

const user = {
  state: {
		themeType: getStore({
			name: 'themeType',
		}) || '',
		cusLogo: getStore({
			name: 'cusLogo',
		}) || '',
    userInfo: getStore({
      name: 'userInfo',
    }) || {},
    roles: getStore({
      name: 'roles',
    }) || [],
    setting: getStore({
      name: 'setting',
    }) || [],
    accessToken: getStore({
      name: 'accessToken',
    }) || '',
    refreshToken: getStore({
      name: 'refreshToken',
    }) || '',
    pms: getStore({
      name: 'pms'
    }) || {
      menu: new Set(),
      button: new Set(),
      other: new Set(),
    },
    ygj: getStore({
      name: 'ygj'
    }) || new Set(),
    menu: getStore({
      name: 'menu'
    }) || new Set(),
    branchInfo: getStore({
      name: 'branchInfo'
    }) || {},
    authorizedAgencies: getStore({
      name: 'authorizedAgencies'
    }) || {},
    cusId:getStore({
      name: 'cusId'
    }) || sessionStorage.getItem('cusId') || '',
    cusList:getStore({
      name: 'cusList'
    }) || new Set(),
    cusListTotal:getStore({
      name: 'cusListTotal'
    }) || new Set(),
    filterRoutes: [],
    loadingMenu: false,
    systemData: [
      { id: 'ac050c26053f46d1bb8a13299ab8631e', label: '社保公积金', pid: null, iconCls: "fa fa-info-circle"},
      { id: 'ac050c26053f47d1bb8a13299ab8629e', label: '合同管理', pid: null, iconCls: "fa fa-user-plus" },
      { id: 'aa050c26053f47d1bb8a13299ab8629e', label: '智享签', pid: null, iconCls: "fa fa-file-pdf-o" },
    ],
    isYgj: false
  },
  actions: {
    // 设置Token的值及失效时间间隔
    RefreshToken({
      commit,
      state,
    }) {
      return new Promise((resolve, reject) => {
        requestRefreshToken(state.refreshToken).then((resp) => {
          if(resp.data.code === 406){
            reject(resp);
          } else {
            commit('SET_ACCESS_TOKEN', resp.data.access_token);
            commit('SET_REFRESH_TOKEN', resp.data.refresh_token);
            resolve();
          }
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // 根据用户名、手机号、邮箱登录
    LoginByUsername({
        commit,
        state,
        dispatch,
      }, userInfo) {
      return new Promise((resolve, reject) => {
        commit('SET_ROUTES', []);
        const user = userInfo;
        loginByUsername(user).then((response) => {
        let dataS=JSON.parse(decrypt(response.data))
        response.data=dataS
        if(dataS.success){
            const data = dataS.data;
            const dataMenus = [];
            if (data.ygjList && data.ygjList.length) {
              data.ygjList.forEach(item => {
                item.label = item.name;
                if (item.url) {
                  let prefix = '';
                  if (item.appId == 'ac050c26053f46d1bb8a13299ab8631e' || item.appId == 'ac050c26053f46d1bb8a13299ab8631e') {
                    prefix = '/shebao';
                  }
                  if (item.appId == 'aa050c26053f47d1bb8a13299ab8629e' || item.appId == 'aa050c26053f47d1bb8a13299ab8629e' ) {
                    prefix = '/sign-hr';
                  }
                  if (item.appId == 'ac050c26053f47d1bb8a13299ab8629e' || item.appId == 'ac050c26053f47d1bb8a13299ab8629e' ) {
                    prefix = '/hr';
                  }
                  item.path = '/ygj' + prefix + matchUrl(item.url).path;
                  item.fullPath = '';
                }
                if (data.shebaoFlag) {
                  if (item.appId == 'ac050c26053f46d1bb8a13299ab8631e') {
                    dataMenus.push(item);
                  }
                }
                if (data.zxqFlag) {
                  if (item.appId == 'aa050c26053f47d1bb8a13299ab8629e') {
                    dataMenus.push(item);
                  }
                } else if (data.hetongFlag)  {
                  if (item.appId == 'ac050c26053f47d1bb8a13299ab8629e') {
                    dataMenus.push(item);
                  }
                }
              })
            } else {
              data.ygjList = [];
            }
            commit('SET_ISYJG', false);
            commit('SET_ACCESS_TOKEN', data.access_token);
            commit('SET_REFRESH_TOKEN', data.refresh_token);
            commit('SET_CUS_ID', data.cusId);
            commit('SET_USER_INFO',data);
            commit('SET_BRANCH_INFO', {id:data.branchId});
            commit('SET_PMS', data.pms);
            commit('SET_AUTHORIZED_AGENCIES', data.authorizedAgencies);
            commit('SET_CUS_LIST', data.cusList);
            commit('SET_CUS_LIST_TOTAL', []);
            commit('CLEAR_LOCK');
            resolve(response);
          }
          reject(response);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // 根据用户名、手机号、邮箱登录
    ygjLogon({ commit }, data) {
      return new Promise((resolve, reject) => {
        ygjLogon(data).then((response) => {
          if(response.data.success){
            const data = response.data.data;
            commit('SET_ACCESS_TOKEN', data.access_token);
            commit('SET_REFRESH_TOKEN', data.refresh_token);
            commit('SET_CUS_ID', data.cusId);
            commit('SET_USER_INFO',data);
            commit('SET_BRANCH_INFO', {iisYgjd:data.branchId});
            commit('SET_PMS', data.pms);
            commit('SET_AUTHORIZED_AGENCIES', data.authorizedAgencies);
            commit('SET_CUS_LIST', data.cusList);
            commit('SET_CUS_LIST_TOTAL', []);
            commit('CLEAR_LOCK');
            commit('SET_ISYJG', true);
            resolve(response);
          }
          reject(response);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // 根据手机号登录
    LoginByPhone({
       commit,
       state,
       dispatch,
     }, userInfo) {
      return new Promise((resolve, reject) => {
        commit('SET_ROUTES', []);
        const mobile = userInfo.mobile.trim();
        loginByPhone(mobile, userInfo.code).then((response) => {
          if(!response.data.code){
            const data = response.data;
            commit('SET_ACCESS_TOKEN', data.access_token);
            commit('SET_REFRESH_TOKEN', data.refresh_token);
            commit('SET_PASS', data.pass);
            commit('SET_PMS', data.pms);
            commit('SET_USER_INFO', data);
            commit('SET_CUS_LIST_TOTAL', []);
            commit('SET_CLIENT_INFO', {id:data.clientId});
            commit('SET_TENANT_INFO', {id:data.tenantId});
            commit('SET_MEMBER_INFO', {id:data.memberId});
            commit('SET_AUTHORIZED_MEMBERS', data.authorizedMembers);
            commit('SET_AUTHORIZED_AGENCIES', data.authorizedAgencies);
            commit('CLEAR_LOCK');
            resolve(response);
          }
          reject(response);
        }).catch((error) => {
          reject(error);
        });
      });

    },

    // 缓存用户相关信息
    CacheUser({
      commit,
      state,
    }, { orgId = '', createOrgId = '' }) {
      return new Promise((resolve, reject) => {
        cacheUser(state.userInfo.id, orgId, createOrgId).then((response) => {
          const { enterprise, facilitator, member, unitCustomer, operator } = response.data;
          commit('SET_FACILITATOR_INFO', facilitator);
          commit('SET_ENTERPRISE_INFO', enterprise);
          commit('SET_MEMBER_INFO', member);
          commit('SET_UNIT_CUSTOMER_INFO', unitCustomer);
          commit('SET_OPERATOR_INFO', operator);
          commit('CLEAR_LOCK');
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // 清除缓存
    ClearCache({
       commit,
       state,
     }) {
      return new Promise((resolve, reject) => {
        sessionStorage.clear();
        resolve(true);
      });
    },
    // 登出
    LogOut({
         commit,
         state,
       }) {
      return new Promise((resolve, reject) => {
        logout(state.accessToken, state.refreshToken).then(() => {
          commit('SET_ACCESS_TOKEN', '');
          commit('SET_REFRESH_TOKEN', '');
          commit('SET_CUS_ID', '');
          commit('SET_MENU', []);
          commit('SET_PMS', {});

          commit('SET_USER_INFO', {});
          commit('SET_BRANCH_INFO', {});
          commit('SET_AUTHORIZED_AGENCIES', '');
          commit('DEL_ALL_TAG');
          commit('SET_ROUTES', []);
          resolve();
        }).catch((error) => {
          commit('SET_ACCESS_TOKEN', '');
          commit('SET_REFRESH_TOKEN', '');
          commit('SET_CUS_ID', '');
          commit('SET_MENU', []);
          commit('SET_PMS', {});
          commit('SET_USER_INFO', {});
          commit('SET_BRANCH_INFO', {});
          commit('SET_AUTHORIZED_AGENCIES', '');
          commit('DEL_ALL_TAG');
          commit('SET_ROUTES', []);
          reject();
        });
      });
    },
    // 注销session
    FedLogOut({
      commit,
    }) {
      return new Promise((resolve) => {
        // 清除菜单
        commit('SET_MENU', []);
        commit('SET_SETTING', []);
        // 清除权限
        commit('SET_PERMISSIONS', new Set());
        // 清除用户信息
        commit('SET_USER_INFO', {});
        commit('SET_ACCESS_TOKEN', '');
        commit('SET_REFRESH_TOKEN', '');
        commit('SET_FACILITATOR_ID', '');
        commit('SET_FACILITATOR_PATH', '');
        commit('SET_FACILITATOR_NAME', '');
        commit('SET_ROLES', []);
        commit('DEL_ALL_TAG');
        // removeToken();
        resolve();
      });
    },
    getCusListTotal({commit, state}) {
      boardGetCusList()
        .then(res =>{
          commit('SET_CUS_LIST_TOTAL', res.data.data);
        })
        .catch(error => {
          commit('SET_CUS_LIST_TOTAL', []);
        })
    }
  },
  mutations: {
		SET_THEME_TYPE: (state,themeType) => {
			state.themeType = themeType;
			setStore({
				name: 'themeType',
				content: state.themeType,
				type: 'session',
			});
		},
		SET_CUS_LOGO: (state,cusLogo) => {
			state.cusLogo = cusLogo;
			setStore({
				name: 'cusLogo',
				content: state.cusLogo,
				type: 'session',
			});
		},
    SET_ACCESS_TOKEN: (state, accessToken) => {
      state.accessToken = accessToken;
      setStore({
        name: 'accessToken',
        content: state.accessToken,
        type: 'session',
      });
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
      setStore({
        name: 'userInfo',
        content: state.userInfo,
        type: 'session',
      });
    },
    SET_MENU: (state, menu) => {
      state.menu = menu;
      setStore({
        name: 'menu',
        content: state.menu,
        type: 'session',
      });
    },
    SET_PMS: (state, pms) => {
      state.pms = pms;
      setStore({
        name: 'pms',
        content: state.pms,
        type: 'session',
      });
    },
    // SET_PASS: (state, pass) => {
    //   state.pass = pass;
    //   setStore({
    //     name: 'pass',
    //     content: state.pass,
    //     type: 'session',
    //   });
    // },
    SET_BRANCH_INFO: (state, branchInfo) => {
      state.branchInfo = branchInfo;
      setStore({
        name: 'branchInfo',
        content: state.branchInfo,
        type: 'session',
      });
    },
    SET_REFRESH_TOKEN: (state, refreshToken) => {
      state.refreshToken = refreshToken;
      setStore({
        name: 'refreshToken',
        content: state.refreshToken,
        type: 'session',
      });
    },
    SET_MEMBER_INFO: (state, memberInfo) => {
      state.memberInfo = memberInfo;
      setStore({
        name: 'memberInfo',
        content: state.memberInfo,
        type: 'session',
      });
    },
    SET_CLIENT_INFO: (state, clientInfo) => {
      state.clientInfo = clientInfo;
      setStore({
        name: 'clientInfo',
        content: state.clientInfo,
        type: 'session',
      });
    },
    SET_AUTHORIZED_MEMBERS: (state, authorizedMembers) => {
      state.authorizedMembers = authorizedMembers;
      setStore({
        name: 'authorizedMembers',
        content: state.authorizedMembers,
        type: 'session',
      });
    },
    SET_AUTHORIZED_AGENCIES: (state, authorizedAgencies) => {
      state.authorizedAgencies = authorizedAgencies;
      setStore({
        name: 'authorizedAgencies',
        content: state.authorizedAgencies,
        type: 'session',
      });
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting;
      setStore({
        name: 'setting',
        content: state.setting,
        type: 'session',
      });
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
      setStore({
        name: 'roles',
        content: state.roles,
        type: 'session',
      });
    },
    SET_CUS_ID: (state, cusId) => {
      state.cusId = cusId;
      setStore({
        name: 'cusId',
        content: state.cusId,
        type: 'session',
      });
    },
    SET_CUS_LIST: (state, cusList) => {
      state.cusList = cusList;
      setStore({
        name: 'cusList',
        content: state.cusList,
        type: 'session',
      });
    },
    SET_CUS_LIST_TOTAL: (state, cusList) => {
      state.cusListTotal = cusList;
      setStore({
        name: 'cusListTotal',
        content: state.cusListTotal,
        type: 'session',
      });
    },
    SET_ROUTES: (state, filterRoutes) => {
      state.filterRoutes = filterRoutes;
      setStore({
        name: 'filterRoutes',
        content: state.filterRoutes,
        type: 'session',
      });
    },
    SET_MENU_LOADING: (state, isLoading) => {
      state.loadingMenu = isLoading;
    },
    SET_ISYGJ: (state, value) => {
      state.isYgj = value;
      setStore({
        name: 'isYgj',
        content: state.isYgj,
        type: 'session',
      });
    }
  }
};
export default user;
